/**
 * Device Storage API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { FieldExistsFilterDefinition } from './fieldExistsFilterDefinition';


export interface CollarRequestDto { 
    airtimeNetworkStatusChangeRequestedFilter?: boolean;
    animalSpeciesIdFilter?: Array<string>;
    batteryTypeIdFilter?: Array<string>;
    comIdsFilter?: Array<string>;
    comTypeFilter?: Array<CollarRequestDto.ComTypeFilterEnum>;
    count?: number;
    customerContactFilter?: Array<string>;
    customerRefNoFilter?: Array<string>;
    dataPlanFilter?: Array<CollarRequestDto.DataPlanFilterEnum>;
    deviceIdsFilter?: Array<number>;
    deviceTypeIdFilter?: Array<string>;
    firmwareVersionIdFilter?: Array<string>;
    genericFieldExistsFilter?: Array<Array<FieldExistsFilterDefinition>>;
    gpsPlusDeviceFilter?: boolean;
    hasCamera?: boolean;
    hasExternalDropOff?: boolean;
    hasInternalDropOff?: boolean;
    hasVhfBeaconTransmitter?: boolean;
    networkStatusFilter?: Array<CollarRequestDto.NetworkStatusFilterEnum>;
    orderBy?: string;
    orderDirection?: string;
    orderItemConfigurationIdFilter?: Array<string>;
    page?: number;
    parametersSet?: Array<string>;
    paymentAccountFilter?: Array<number>;
    pcbTypeIdFilter?: Array<string>;
    replacedByIdFilter?: Array<number>;
    rmaIdFilter?: Array<string>;
    shippingDateAfterFilter?: string;
    shippingDateBeforeFilter?: string;
    testDeviceFilter?: boolean;
    userSubsystemIdentifierVisibilityEnabled?: Array<number>;
}
export namespace CollarRequestDto {
    export const ComTypeFilterEnum = {
        Iridium: 'IRIDIUM',
        Globalstar: 'GLOBALSTAR',
        NbIot: 'NB_IOT',
        NoCommunication: 'NO_COMMUNICATION',
        Gsm: 'GSM'
    } as const;
    export type ComTypeFilterEnum = typeof ComTypeFilterEnum[keyof typeof ComTypeFilterEnum];
    export const DataPlanFilterEnum = {
        Unlimited: 'UNLIMITED',
        ThreeKbyte: 'THREE_KBYTE',
        SmithsonianSpecial: 'SMITHSONIAN_SPECIAL',
        PooledThreeKbyte: 'POOLED_THREE_KBYTE',
        PooledTwelveKbyte: 'POOLED_TWELVE_KBYTE',
        Test25Kbyte: 'TEST_2_5_KBYTE',
        Test4Kbyte: 'TEST_4_KBYTE'
    } as const;
    export type DataPlanFilterEnum = typeof DataPlanFilterEnum[keyof typeof DataPlanFilterEnum];
    export const NetworkStatusFilterEnum = {
        Activating: 'ACTIVATING',
        Activated: 'ACTIVATED',
        Deactivating: 'DEACTIVATING',
        Deactivated: 'DEACTIVATED',
        Suspending: 'SUSPENDING',
        Resuming: 'RESUMING',
        Changing: 'CHANGING',
        Invalid: 'INVALID',
        Changed: 'CHANGED'
    } as const;
    export type NetworkStatusFilterEnum = typeof NetworkStatusFilterEnum[keyof typeof NetworkStatusFilterEnum];
}


export type ComTypeFilterEnum = typeof CollarRequestDto.ComTypeFilterEnum[keyof typeof CollarRequestDto.ComTypeFilterEnum];
export type DataPlanFilterEnum = typeof CollarRequestDto.DataPlanFilterEnum[keyof typeof CollarRequestDto.DataPlanFilterEnum];
export type NetworkStatusFilterEnum = typeof CollarRequestDto.NetworkStatusFilterEnum[keyof typeof CollarRequestDto.NetworkStatusFilterEnum];
